module.exports = __webpack_public_path__ + "img/INF-A-3-I.a0241959.png";